import type {ComponentDataAndProps, ComponentProps, MetaData} from '@enonic/react-components'
import {BaseComponent} from '@enonic/react-components'
import * as React from 'react'
import {Section} from './Section'
import {Container} from './Container'

export interface SiteRegionProps {
  name: string
  data: ComponentDataAndProps[]
  meta: MetaData
  common?: ComponentProps['common']
  className?: string
}

export const SiteRegion: React.FC<SiteRegionProps> = ({name, data, meta, common, className}) => {
  if (!name) {
    throw new Error('SiteRegion requires a name prop.')
  }

  return (
    <div
      className={['xp-region', className].filter(Boolean).join(' ')}
      data-portal-region={name}
    >
      {data.map((entry, index) => {
        const {component, data: componentData} = entry

        if (component.type === 'text') {
          return (
            <Section key={index}>
              <Container>
                <div className="col-span-full md:col-span-8 md:col-start-3 site-prose prose-flush">
                  <BaseComponent
                    component={component}
                    data={componentData}
                    common={common}
                    meta={meta}
                  />
                </div>
              </Container>
            </Section>
          )
        }

        return (
          <BaseComponent
            key={index}
            component={component}
            data={componentData}
            common={common}
            meta={meta}
          />
        )
      })}
    </div>
  )
}
